/**
 * @module utils/object
 */

/**
 * @typedef {Object|null} Target
 * @typedef {{}} Extension
 * @typedef {Target|Extension} Object
 */

import inherits from './inherits.js'

const { assign, create, getOwnPropertyDescriptors, freeze, prototype } = Object

/**
 * Merges any number of object to a new frozen one
 * @param {Target} target
 * @param {...Extension} extensions
 * @returns {Object}
 */
export default (
  target = null,
  ...extensions
) => {
  if (inherits(target, prototype)) {
    throw new TypeError('Unable to extend a plain object')
  }

  const descriptors = getOwnPropertyDescriptors(assign({}, target, ...extensions))
  const clone = create(target, descriptors)

  freeze(clone)

  return clone
}
